<template>
    <v-card class="mt-3">
        <v-list-item class="title__stys">
            <div class="white--text title__sty">
                {{$t('ProductReceipt_title1')}}
            </div>
            <v-spacer></v-spacer>
            <div>
                <v-btn
                    class="mr-1 subtitle__sty"
                    depressed
                    small
                    @click="onReimburseChange()"
                >
                    {{$t('ProductReceipt_button1')}}
                </v-btn>
            </div>
        </v-list-item>
        <v-divider></v-divider>
        <div class="px-4 py-2">
            <span class="detialinfo__sty">
                {{$t('ProductReceipt_text1')}}
            </span>
            <v-divider class="my-4"></v-divider>
            <div>
                <v-radio-group
                    v-model="ReceiptradioGroup"
                    row
                >
                    <!-- <v-radio
                        label="同收貨人地址"
                        value="1"
                    ></v-radio> -->
                    <v-radio
                        :label="$t('ProductReceipt_input1')"
                        value="2"
                    ></v-radio>
                </v-radio-group>
            </div>
            <div v-show="showarea.reimburse">
                <span class="infotitle__sty">{{$t('ProductReceipt_text2')}}</span>
                <v-text-field
                    :label="reimbursecheckbox[0].name"
                    v-model.lazy="$store.state.userinfo.userinfoData[0].receipt_company_id"
                    outlined
                    dense
                    class="input__sty"
                ></v-text-field>
                <span class="infotitle__sty">{{$t('ProductReceipt_text3')}}</span>
                <v-text-field
                    :label="reimbursecheckbox[1].name"
                    v-model.lazy="$store.state.userinfo.userinfoData[0].receipt_company_name"
                    outlined
                    dense
                    class="input__sty"
                ></v-text-field>
            </div>
            <v-checkbox
                :label="$t('ProductReceipt_input2')"
                v-model="isreimburse"
                @change="isReimburse"
            />
        </div>
    </v-card>
</template>

<script>
    export default {
        name: 'ProductReceipt',
        props: ['getreceiptinfodata'],

        data: function () {
            return {
                // 報帳
                reimbursecheckbox: [
                    {
                        'name': this.$t('ProductReceipt_input3'),
                        'reimburse_info': this.getreceiptinfodata[0].receipt_company_id,
                    },
                    {
                        'name': this.$t('ProductReceipt_input4'),
                        'reimburse_info': this.getreceiptinfodata[0].receipt_company_name,
                    }
                ],
                isreimburse: false,
                showarea: {
                    reimburse: false
                },
                // 發票寄送選擇 1: 收貨人 2: 訂購人
                ReceiptradioGroup: "2",
            }
        },
        methods: {
            // 清除統編
            onReimburseChange() {
                this.reimbursecheckbox[0].reimburse_info = '';
                this.reimbursecheckbox[1].reimburse_info = '';
                this.isreimburse = false;
                this.showarea.reimburse = false;
                this.$store.state.userinfo.userinfoData[0].receipt_company_id = '';
                this.$store.state.userinfo.userinfoData[0].receipt_company_name = '';
            },
            // 報帳
            isReimburse(event) {
                if (event === true) {
                    this.showarea.reimburse = true;
                } else {
                    this.showarea.reimburse = false;
                }
            }
        },
        mounted() {
        }
    }
</script>

<style lang="sass">
    .input__sty .v-text-field__details, .input__sty .v-messages
        min-height: unset
</style>
<style scoped lang="sass">
    .title__stys
        background-color: #352D40
    .title__sty
        font-weight: bold
        font-size: 15px
        letter-spacing: 0.1em
    .subtitle__sty
        background: #D2DDF0
        color: #352D40
        font-weight: bold
        font-size: 13px
        letter-spacing: 0.1em
    .infotitle__sty
        color: #352D40
        font-weight: bold
        font-size: 13px
        letter-spacing: 0.1em
    .detialinfo__sty
        color: #352D40
        font-weight: bold
        font-size: 13px
        letter-spacing: 0.1em
</style>
